import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, pimsService } from '@v2/services';

interface UseToggleConnectivityResult {
  toggleConnectivity: (pimsId: string) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const useToggleConnectivity = (): UseToggleConnectivityResult => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: pimsService.toggleConnectivity,
    onSuccess: (_data, pimsId) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pims.detail(pimsId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.pims.lists() });
    },
  });

  return {
    toggleConnectivity: mutation.mutateAsync,
    loading: mutation.isPending,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useToggleConnectivity;
